var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"root"},[_c('div',{staticClass:"main-content"},[_vm._t("default"),_c('DfxViewer',{ref:"viewer",attrs:{"dxfUrl":_vm.dxfUrl,"fonts":_vm.fonts},on:{"dxf-loaded":_vm.onLoaded,"dxf-cleared":_vm.onCleared,"dxf-message":_vm.onMessage}})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }